import React from 'react';
export const FormSection = ({ children, title }) => (React.createElement("div", { className: "form-section" },
    title && React.createElement("h2", { className: "form-section__title" }, title),
    React.createElement("div", { className: "form-section__content" }, children)));
//# sourceMappingURL=FormSection.js.map